// // import React, { useState, useEffect, useCallback } from "react";
// // import {
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Pagination,
// //   Card,
// //   TextField,
// //   CircularProgress,
// //   Box,
// //   Stack,
// //   IconButton,
// //   Skeleton,
// //   Modal,
// //   Button,
// //   Tooltip,
// // } from "@mui/material";
// // import { MdVisibility, MdDelete } from "react-icons/md";
// // import axios from "axios";
// // import { useNavigate } from "react-router-dom";
// // import debounce from "lodash.debounce";
// // import dayjs from "dayjs";

// // const OfferList = () => {
// //   const navigate = useNavigate();
// //   const [data, setData] = useState([]);
// //   const [totalPages, setTotalPages] = useState(1);
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [loading, setLoading] = useState(false);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [deleteOpen, setDeleteOpen] = useState(false);
// //   const [selectedPromocodeId, setSelectedPromocodeId] = useState(null);
// //   useEffect(() => {
// //     fetchData(currentPage, searchQuery);
// //   }, [currentPage, searchQuery]);

// //   const fetchData = useCallback(
// //     debounce(async (page, query) => {
// //       setLoading(true);
// //       try {
// //         const { data } = await axios.get(
// //           `https://api.medstown.com/customer/history/orders?page=${page}&search=${query}`
// //         );
// //         console.log(data?.data);
// //         setData(data);
// //         // setTotalPages(Math.ceil(data.data.totalPromocodes / 10));
// //         setTotalPages(data.totalPages);
// //       } catch (error) {
// //         console.error("Error fetching data:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     }, 500),
// //     []
// //   );

// //   useEffect(() => {
// //     fetchData(currentPage, searchQuery);
// //   }, [currentPage, searchQuery, fetchData]);
// //   const handlePageChange = (event, value) => {
// //     setCurrentPage(value);
// //   };

// //   const handleSearch = (e) => {
// //     setSearchQuery(e.target.value);
// //   };

// //   // Delete Multiple Documents

// //   const handleConfirmDeletePromocode = async () => {
// //     try {
// //       const res = await fetch(
// //         `https://api.medstown.com/api/admin-controls/order/${selectedPromocodeId}`,
// //         {
// //           method: "DELETE",
// //         }
// //       );
// //       const data = await res.json();

// //       if (res.ok) {
// //         alert("Promocode deleted successfully");
// //         // Refresh list if needed
// //         fetchData(currentPage, searchQuery);
// //       } else {
// //         alert(data.message || "Failed to delete promocode");
// //       }
// //     } catch (err) {
// //       alert("Server error");
// //       console.error(err);
// //     } finally {
// //       setDeleteOpen(false);
// //       setSelectedPromocodeId(null);
// //     }
// //   };

// //   return (
// //     <>
// //       <Card sx={{ marginTop: 4, py: 2, borderRadius: "10px" }}>
// //         <Stack
// //           direction="row"
// //           justifyContent="space-between"
// //           alignItems="center"
// //           mt={2}
// //         >
// //           <TextField
// //             variant="outlined"
// //             size="medium"
// //             placeholder="Search by Order Id or Customer Name or Customer Phone Number"
// //             onChange={handleSearch}
// //             sx={{
// //               padding: 2,
// //               width: "50%",
// //               "& .MuiOutlinedInput-root": {
// //                 "& fieldset": {
// //                   borderColor: "black", // normal state
// //                 },
// //                 "&:hover fieldset": {
// //                   borderColor: "black", // hover state
// //                 },
// //                 "&.Mui-focused fieldset": {
// //                   borderColor: "black", // focus state
// //                 },
// //               },
// //             }}
// //           />
// //         </Stack>
// //         <TableContainer>
// //           <Table>
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
// //                   Order Id
// //                 </TableCell>
// //                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
// //                   Order Type
// //                 </TableCell>

// //                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
// //                   Customer Name
// //                 </TableCell>
// //                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
// //                   Customer Phone Number
// //                 </TableCell>
// //                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
// //                   {" "}
// //                   Total Price
// //                 </TableCell>
// //                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
// //                   Payment Type
// //                 </TableCell>
// //                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
// //                   Status
// //                 </TableCell>
// //                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
// //                   Order createdAt
// //                 </TableCell>
// //                 <TableCell style={{ fontWeight: 600, fontSize: 13 }}>
// //                   Action
// //                 </TableCell>
// //               </TableRow>
// //             </TableHead>

// //             <TableBody>
// //               {loading
// //                 ? Array.from(new Array(5)).map((_, index) => (
// //                     <TableRow key={index}>
// //                       {[...Array(9)].map((_, i) => (
// //                         <TableCell key={i}>
// //                           <Skeleton variant="text" width="100%" />
// //                         </TableCell>
// //                       ))}
// //                     </TableRow>
// //                   ))
// //                 : data?.list?.map((item) => (
// //                     <TableRow key={item._id}>
// //                       <TableCell
// //                         sx={{
// //                           maxWidth: 150,
// //                           whiteSpace: "nowrap",
// //                           overflow: "hidden",
// //                           textOverflow: "ellipsis",
// //                         }}
// //                       >
// //                         {item.orderId}
// //                       </TableCell>
// //                       <TableCell>
// //                         {item.orderType.replace("Pharmacy", "").trim()}
// //                       </TableCell>
// //                       <TableCell>{item.customerName}</TableCell>
// //                       <TableCell>{item.customerPhone}</TableCell>
// //                       <TableCell>₹ {item.totalPrice}</TableCell>
// //                       <TableCell>{item.paymentType}</TableCell>
// //                       <TableCell>{item.status}</TableCell>
// //                       <TableCell>
// //                         {dayjs(item.createdAt).format("DD MMM YYYY, hh:mm A")}
// //                       </TableCell>
// //                       <TableCell>
// //                         <Stack direction="row" spacing={1}>
// //                           {/* View Button */}
// //                           <IconButton
// //                             onClick={() =>
// //                               navigate(`/admin/open-order/${item.orderId}`)
// //                             }
// //                             sx={{ color: "#014D4D" }}
// //                           >
// //                             <MdVisibility size={20} />
// //                           </IconButton>
// //                           {/* Delete Button  */}
// //                           <Tooltip label="delete is not working">
// //                             <IconButton
// //                               onClick={() => {
// //                                 setSelectedPromocodeId(item.orderId);
// //                                 setDeleteOpen(true);
// //                               }}
// //                               color="secondary"
// //                             >
// //                               <MdDelete size={20} />
// //                             </IconButton>
// //                           </Tooltip>
// //                         </Stack>
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>

// //         {/* Pagination */}
// //         <Pagination
// //           count={totalPages}
// //           page={currentPage}
// //           onChange={handlePageChange}
// //           sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}
// //         />
// //       </Card>
// //       {/* delete modal */}
// //       <Modal
// //         open={deleteOpen}
// //         onClose={() => {
// //           setDeleteOpen(false);
// //           setSelectedPromocodeId(null);
// //         }}
// //         aria-labelledby="delete-promocode-title"
// //         aria-describedby="delete-promocode-description"
// //       >
// //         <Box sx={deleteModalStyle}>
// //           <h4 className="text-2xl font-bold">Delete Order history</h4>
// //           <p>
// //             Are you sure you want to delete this Order history ? This action
// //             cannot be undone.
// //           </p>
// //           <Box className="mt-4 flex justify-end gap-2">
// //             <Button
// //               onClick={handleConfirmDeletePromocode}
// //               variant="contained"
// //               color="error"
// //             >
// //               Delete
// //             </Button>
// //             <Button
// //               onClick={() => {
// //                 setDeleteOpen(false);
// //                 setSelectedPromocodeId(null);
// //               }}
// //               variant="outlined"
// //             >
// //               Cancel
// //             </Button>
// //           </Box>
// //         </Box>
// //       </Modal>
// //     </>
// //   );
// // };
// // const deleteModalStyle = {
// //   position: "absolute",
// //   top: "50%",
// //   left: "50%",
// //   transform: "translate(-50%, -50%)",
// //   width: 500,
// //   bgcolor: "background.paper",
// //   borderRadius: 2,
// //   boxShadow: 24,
// //   p: 4,
// // };
// // export default OfferList;



// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Pagination,
//   Card,
//   TextField,
//   Box,
//   Stack,
//   IconButton,
//   Skeleton,
//   Modal,
//   Button,
//   Tooltip,
//   Typography,
//   Avatar,
//   Chip,
//   InputAdornment,
//   useTheme,
//   alpha,
//   LinearProgress,
//   Fade,
//   Alert,
//   PaginationItem,
// } from "@mui/material";
// import {
//   MdVisibility,
//   MdDelete,
//   MdSearch,
//   MdClear,
//   MdInbox,
//   MdWarning,
//   MdArrowBack,
//   MdArrowForward,
//   MdPhone,
//   MdCalendarToday,
// } from "react-icons/md";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import debounce from "lodash.debounce";
// import dayjs from "dayjs";

// const OfferList = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const [data, setData] = useState({ list: [], totalCount: 0, totalPages: 1, currentPage: 1 });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [deleteOpen, setDeleteOpen] = useState(false);
//   const [selectedPromocodeId, setSelectedPromocodeId] = useState(null);
//   const [error, setError] = useState(null);
//   const [searchLoading, setSearchLoading] = useState(false);

//   const getStatusConfig = (status) => {
//     const normalizedStatus = status?.toLowerCase();
//     const configs = {
//       "delivered": {
//         color: "#4caf50",
//         bgColor: alpha("#4caf50", 0.1),
//       },
//       "pending": {
//         color: "#ff9800",
//         bgColor: alpha("#ff9800", 0.1),
//       },
//       "processing": {
//         color: "#2196f3",
//         bgColor: alpha("#2196f3", 0.1),
//       },
//       "confirmed": {
//         color: "#9c27b0",
//         bgColor: alpha("#9c27b0", 0.1),
//       },
//       "order cancelled": {
//         color: "#f44336",
//         bgColor: alpha("#f44336", 0.1),
//       },
//       "cancelled": {
//         color: "#f44336",
//         bgColor: alpha("#f44336", 0.1),
//       }
//     };
//     return configs[normalizedStatus] || {
//       color: "#757575",
//       bgColor: alpha("#757575", 0.1),
//     };
//   };

//   const getPaymentTypeConfig = (type) => {
//     const configs = {
//       "COD": {
//         color: "#ff5722",
//         bgColor: alpha("#ff5722", 0.1)
//       },
//       "Online": {
//         color: "#4caf50",
//         bgColor: alpha("#4caf50", 0.1)
//       },
//       "UPI": {
//         color: "#673ab7",
//         bgColor: alpha("#673ab7", 0.1)
//       },
//       "Card": {
//         color: "#009688",
//         bgColor: alpha("#009688", 0.1)
//       }
//     };
//     return configs[type] || {
//       color: "#757575",
//       bgColor: alpha("#757575", 0.1)
//     };
//   };

//   const fetchData = useCallback(
//     debounce(async (page, query) => {
//       setLoading(true);
//       setSearchLoading(true);
//       setError(null);
      
//       try {
//         const { data: responseData } = await axios.get(
//           `https://api.medstown.com/customer/history/orders?page=${page}&search=${query}`
//         );
        
//         setData(responseData);
//         if (responseData.currentPage) {
//           setCurrentPage(responseData.currentPage);
//         }
        
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setError(error.response?.data?.message || "Failed to fetch order history. Please try again.");
//         setData({ list: [], totalCount: 0, totalPages: 1, currentPage: 1 });
//       } finally {
//         setLoading(false);
//         setSearchLoading(false);
//       }
//     }, 500),
//     []
//   );

//   useEffect(() => {
//     fetchData(currentPage, searchQuery);
//   }, [currentPage, searchQuery, fetchData]);

//   const handlePageChange = (event, value) => {
//     setCurrentPage(value);
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//     setSearchLoading(true);
//   };

//   const clearSearch = () => {
//     setSearchQuery("");
//     setCurrentPage(1);
//   };

//   const handleConfirmDeletePromocode = async () => {
//     try {
//       const res = await fetch(
//         `https://api.medstown.com/api/admin-controls/order/${selectedPromocodeId}`,
//         {
//           method: "DELETE",
//         }
//       );
//       const data = await res.json();

//       if (res.ok) {
//         alert("Order deleted successfully");
//         fetchData(currentPage, searchQuery);
//       } else {
//         alert(data.message || "Failed to delete order");
//       }
//     } catch (err) {
//       alert("Server error");
//       console.error(err);
//     } finally {
//       setDeleteOpen(false);
//       setSelectedPromocodeId(null);
//     }
//   };

//   return (
//     <>
//       <Card sx={{ 
//         mt: 3, 
//         borderRadius: 3, 
//         boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
//         border: '1px solid',
//         borderColor: alpha(theme.palette.divider, 0.1),
//         overflow: 'hidden'
//       }}>
//         {/* Loading Progress Bar */}
//         {loading && (
//           <LinearProgress 
//             sx={{ 
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               right: 0,
//               zIndex: 1,
//               height: 3,
//               '& .MuiLinearProgress-bar': {
//                 background: 'linear-gradient(90deg, #2196f3, #21cbf3, #2196f3)'
//               }
//             }} 
//           />
//         )}

//         {/* Header with Advanced Search */}
//         <Box sx={{ p: 3, pb: 2 }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={3}>
//             <Box>
//               <Typography variant="h5" fontWeight={700} color="primary.main" sx={{ mb: 0.5 }}>
//                 Order History
//               </Typography>
//               {/* <Typography variant="body2" color="text.secondary">
//                 {data?.totalCount || 0} total orders • Page {currentPage} of {data?.totalPages || 1}
//               </Typography> */}
//             </Box>

//             {/* Advanced Search Bar */}
//             <Box sx={{ position: 'relative' }}>
//               <TextField
//                 variant="outlined"
//                 size="medium"
//                 placeholder="Search by Order ID, Customer Name, or Phone..."
//                 value={searchQuery}
//                 onChange={handleSearch}
//                 sx={{
//                   width: 400,
//                   '& .MuiOutlinedInput-root': {
//                     backgroundColor: alpha(theme.palette.background.paper, 0.8),
//                     backdropFilter: 'blur(10px)',
//                     borderRadius: 3,
//                     fontSize: '0.875rem',
//                     transition: 'all 0.3s ease',
//                     '& fieldset': {
//                       borderColor: alpha(theme.palette.primary.main, 0.2),
//                       borderWidth: 2,
//                     },
//                     '&:hover': {
//                       backgroundColor: alpha(theme.palette.background.paper, 1),
//                       '& fieldset': {
//                         borderColor: alpha(theme.palette.primary.main, 0.4),
//                       },
//                     },
//                     '&.Mui-focused': {
//                       backgroundColor: alpha(theme.palette.background.paper, 1),
//                       boxShadow: `0 0 0 4px ${alpha(theme.palette.primary.main, 0.1)}`,
//                       '& fieldset': {
//                         borderColor: theme.palette.primary.main,
//                       },
//                     },
//                   },
//                 }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       {searchLoading ? (
//                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                           <LinearProgress 
//                             sx={{ 
//                               width: 20, 
//                               height: 2,
//                               borderRadius: 1
//                             }} 
//                           />
//                         </Box>
//                       ) : (
//                         <MdSearch size={20} color={theme.palette.primary.main} />
//                       )}
//                     </InputAdornment>
//                   ),
//                   endAdornment: searchQuery && (
//                     <InputAdornment position="end">
//                       <IconButton
//                         size="small"
//                         onClick={clearSearch}
//                         sx={{ 
//                           color: theme.palette.text.secondary,
//                           '&:hover': { 
//                             backgroundColor: alpha(theme.palette.error.main, 0.1),
//                             color: theme.palette.error.main 
//                           }
//                         }}
//                       >
//                         <MdClear size={18} />
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Box>
//           </Stack>

//           {/* Error Alert */}
//           {error && (
//             <Fade in={!!error}>
//               <Alert 
//                 severity="error" 
//                 sx={{ mt: 2, borderRadius: 2 }}
//                 icon={<MdWarning />}
//                 action={
//                   <IconButton
//                     size="small"
//                     onClick={() => setError(null)}
//                     sx={{ color: 'inherit' }}
//                   >
//                     <MdClear size={16} />
//                   </IconButton>
//                 }
//               >
//                 {error}
//               </Alert>
//             </Fade>
//           )}
//         </Box>

//         <TableContainer sx={{ px: 3 }}>
//           <Table size="small" sx={{ '& .MuiTableCell-root': { py: 2 } }}>
//             <TableHead>
//               <TableRow sx={{ '& .MuiTableCell-head': { 
//                 backgroundColor: alpha(theme.palette.primary.main, 0.06),
//                 fontWeight: 700,
//                 fontSize: '0.8rem',
//                 color: theme.palette.primary.main,
//                 border: 'none',
//                 py: 2,
//                 textTransform: 'uppercase',
//                 letterSpacing: '0.5px'
//               }}}>
//                 <TableCell>Order ID</TableCell>
//                 <TableCell>Type</TableCell>
//                 <TableCell>Customer</TableCell>
//                 <TableCell>Contact</TableCell>
//                 <TableCell align="right">Amount</TableCell>
//                 <TableCell>Payment</TableCell>
//                 <TableCell>Status</TableCell>
//                 <TableCell>Created</TableCell>
//                 <TableCell align="center">Actions</TableCell>
//               </TableRow>
//             </TableHead>

//             <TableBody>
//               {loading && !data?.list?.length ? (
//                 Array.from(new Array(6)).map((_, index) => (
//                   <TableRow key={index}>
//                     {[...Array(9)].map((_, i) => (
//                       <TableCell key={i}>
//                         <Skeleton 
//                           variant="rectangular" 
//                           height={28} 
//                           sx={{ borderRadius: 1.5, bgcolor: alpha(theme.palette.primary.main, 0.05) }} 
//                         />
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 ))
//               ) : data?.list?.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={9} align="center" sx={{ py: 8 }}>
//                     <Stack direction="column" alignItems="center" spacing={3}>
//                       <Avatar sx={{ 
//                         bgcolor: alpha(theme.palette.primary.main, 0.1),
//                         width: 72,
//                         height: 72
//                       }}>
//                         <MdInbox size={36} color={theme.palette.primary.main} />
//                       </Avatar>
//                       <Box textAlign="center">
//                         <Typography variant="h6" color="text.primary" fontWeight={600} sx={{ mb: 1 }}>
//                           No orders found
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           {searchQuery ? 'Try adjusting your search terms' : 'No order history available at the moment'}
//                         </Typography>
//                       </Box>
//                     </Stack>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 data?.list?.map((item) => {
//                   const statusConfig = getStatusConfig(item.status);
//                   const paymentConfig = getPaymentTypeConfig(item.paymentType);
                  
//                   return (
//                     <TableRow 
//                       key={item._id}
//                       sx={{ 
//                         '&:hover': { 
//                           backgroundColor: alpha(theme.palette.primary.main, 0.03),
//                           transform: 'translateY(-1px)',
//                           boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.1)}`
//                         },
//                         borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
//                         transition: 'all 0.2s ease'
//                       }}
//                     >
//                       {/* Order ID */}
//                       <TableCell sx={{ fontSize: '0.8125rem', fontWeight: 600 }}>
//                         <Box component="span" sx={{ 
//                           color: theme.palette.primary.main,
//                           fontFamily: 'monospace',
//                           backgroundColor: alpha(theme.palette.primary.main, 0.08),
//                           px: 1,
//                           py: 0.5,
//                           borderRadius: 1,
//                           fontSize: '0.75rem'
//                         }}>
//                           {item.orderId}
//                         </Box>
//                       </TableCell>
                      
//                       {/* Order Type */}
//                       <TableCell sx={{ fontSize: '0.8125rem' }}>
//                         <Chip 
//                           label={item.orderType?.replace("Pharmacy", "").trim()}
//                           size="small"
//                           variant="outlined"
//                           sx={{ 
//                             fontSize: '0.7rem', 
//                             height: 26,
//                             borderColor: alpha(theme.palette.secondary.main, 0.4),
//                             color: theme.palette.secondary.main,
//                             fontWeight: 500
//                           }}
//                         />
//                       </TableCell>
                      
//                       {/* Customer */}
//                       <TableCell sx={{ fontSize: '0.8125rem', maxWidth: 120 }}>
//                         <Box sx={{ 
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           whiteSpace: 'nowrap',
//                           fontWeight: 500
//                         }}>
//                           {item.customerName}
//                         </Box>
//                       </TableCell>
                      
//                       {/* Contact */}
//                       <TableCell sx={{ fontSize: '0.8125rem' }}>
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                           <MdPhone size={14} color={theme.palette.text.secondary} />
//                           <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.8125rem' }}>
//                             {item.customerPhone}
//                           </Typography>
//                         </Stack>
//                       </TableCell>
                      
//                       {/* Amount */}
//                       <TableCell align="right" sx={{ fontSize: '0.8125rem', fontWeight: 700 }}>
//                         <Box sx={{ color: theme.palette.success.main }}>
//                           ₹{item.totalPrice?.toLocaleString()}
//                         </Box>
//                       </TableCell>
                      
//                       {/* Payment */}
//                       <TableCell sx={{ fontSize: '0.8125rem' }}>
//                         <Chip 
//                           label={item.paymentType}
//                           size="small"
//                           sx={{ 
//                             fontSize: '0.7rem',
//                             height: 24,
//                             backgroundColor: paymentConfig.bgColor,
//                             color: paymentConfig.color,
//                             border: 'none',
//                             fontWeight: 600
//                           }}
//                         />
//                       </TableCell>
                      
//                       {/* Status */}
//                       <TableCell sx={{ fontSize: '0.8125rem' }}>
//                         <Chip 
//                           label={item.status}
//                           size="small"
//                           sx={{ 
//                             fontSize: '0.7rem',
//                             height: 26,
//                             backgroundColor: statusConfig.bgColor,
//                             color: statusConfig.color,
//                             border: `1px solid ${alpha(statusConfig.color, 0.3)}`,
//                             fontWeight: 600
//                           }}
//                         />
//                       </TableCell>

//                       {/* Created Date */}
//                       <TableCell sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                           <MdCalendarToday size={14} />
//                           <Box>
//                             <Box sx={{ fontWeight: 500 }}>
//                               {dayjs(item.createdAt).format("MMM DD")}
//                             </Box>
//                             <Box sx={{ fontSize: '0.7rem', opacity: 0.8 }}>
//                               {dayjs(item.createdAt).format("hh:mm A")}
//                             </Box>
//                           </Box>
//                         </Stack>
//                       </TableCell>
                      
//                       {/* Actions */}
//                       <TableCell align="center">
//                         <Stack direction="row" spacing={1} justifyContent="center">
//                           {/* View Button */}
//                           <Tooltip title="View Order Details">
//                             <IconButton
//                               size="small"
//                               onClick={() => navigate(`/admin/open-order/${item.orderId}`)}
//                               sx={{ 
//                                 color: theme.palette.primary.main,
//                                 backgroundColor: alpha(theme.palette.primary.main, 0.1),
//                                 border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//                                 '&:hover': {
//                                   backgroundColor: alpha(theme.palette.primary.main, 0.2),
//                                   transform: 'scale(1.05)',
//                                   boxShadow: `0 4px 8px ${alpha(theme.palette.primary.main, 0.3)}`
//                                 },
//                                 transition: 'all 0.2s ease'
//                               }}
//                             >
//                               <MdVisibility size={16} />
//                             </IconButton>
//                           </Tooltip>

//                           {/* Delete Button */}
//                           <Tooltip title="Delete Order (Not Working)">
//                             <IconButton
//                               size="small"
//                               onClick={() => {
//                                 setSelectedPromocodeId(item.orderId);
//                                 setDeleteOpen(true);
//                               }}
//                               sx={{ 
//                                 color: theme.palette.error.main,
//                                 backgroundColor: alpha(theme.palette.error.main, 0.1),
//                                 border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
//                                 '&:hover': {
//                                   backgroundColor: alpha(theme.palette.error.main, 0.2),
//                                   transform: 'scale(1.05)',
//                                   boxShadow: `0 4px 8px ${alpha(theme.palette.error.main, 0.3)}`
//                                 },
//                                 transition: 'all 0.2s ease'
//                               }}
//                             >
//                               <MdDelete size={16} />
//                             </IconButton>
//                           </Tooltip>
//                         </Stack>
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Enhanced Pagination */}
//         <Box sx={{ p: 3, pt: 2 }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             {/* Results Info */}
//             <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
//               Showing {data?.list?.length || 0} of {data?.totalCount || 0} orders
//             </Typography>

//             {/* Pagination */}
//             {data?.totalPages > 1 && (
//               <Pagination
//                 count={data?.totalPages || 1}
//                 page={currentPage}
//                 onChange={handlePageChange}
//                 size="medium"
//                 variant="outlined"
//                 shape="rounded"
//                 renderItem={(item) => (
//                   <PaginationItem
//                     slots={{ previous: MdArrowBack, next: MdArrowForward }}
//                     {...item}
//                     sx={{
//                       fontSize: '0.875rem',
//                       minWidth: 36,
//                       height: 36,
//                       margin: '0 2px',
//                       borderRadius: 2,
//                       border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//                       '&.Mui-selected': {
//                         backgroundColor: theme.palette.primary.main,
//                         color: 'white',
//                         fontWeight: 600,
//                         border: `1px solid ${theme.palette.primary.main}`,
//                         '&:hover': {
//                           backgroundColor: alpha(theme.palette.primary.main, 0.8),
//                         }
//                       },
//                       '&:hover': {
//                         backgroundColor: alpha(theme.palette.primary.main, 0.1),
//                         borderColor: alpha(theme.palette.primary.main, 0.4),
//                       }
//                     }}
//                   />
//                 )}
//               />
//             )}
//           </Stack>
//         </Box>
//       </Card>

//       {/* Enhanced Delete Modal */}
//       <Modal
//         open={deleteOpen}
//         onClose={() => {
//           setDeleteOpen(false);
//           setSelectedPromocodeId(null);
//         }}
//         closeAfterTransition
//       >
//         <Fade in={deleteOpen}>
//           <Box sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 480,
//             bgcolor: "background.paper",
//             borderRadius: 3,
//             boxShadow: `0 24px 48px ${alpha(theme.palette.common.black, 0.15)}`,
//             p: 4,
//             border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
//           }}>
//             {/* Modal Header */}
//             <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
//               <Avatar sx={{
//                 backgroundColor: alpha(theme.palette.error.main, 0.1),
//                 color: theme.palette.error.main,
//                 width: 48,
//                 height: 48
//               }}>
//                 <MdWarning size={24} />
//               </Avatar>
//               <Box>
//                 <Typography variant="h5" fontWeight={700} color="error.main">
//                   Delete Order History
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   This action cannot be undone
//                 </Typography>
//               </Box>
//             </Stack>

//             {/* Modal Content */}
//             <Box sx={{ 
//               backgroundColor: alpha(theme.palette.error.main, 0.05),
//               p: 3,
//               borderRadius: 2,
//               border: `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
//               mb: 4
//             }}>
//               <Typography variant="body1" sx={{ mb: 2 }}>
//                 Are you sure you want to delete this order history?
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 <strong>Order ID:</strong> #{selectedPromocodeId}
//               </Typography>
//             </Box>

//             {/* Modal Actions */}
//             <Stack direction="row" spacing={2} justifyContent="flex-end">
//               <Button
//                 variant="outlined"
//                 onClick={() => {
//                   setDeleteOpen(false);
//                   setSelectedPromocodeId(null);
//                 }}
//                 sx={{
//                   borderColor: alpha(theme.palette.text.secondary, 0.3),
//                   color: 'text.secondary',
//                   '&:hover': {
//                     borderColor: theme.palette.text.secondary,
//                     backgroundColor: alpha(theme.palette.text.secondary, 0.05)
//                   }
//                 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained"
//                 color="error"
//                 onClick={handleConfirmDeletePromocode}
//                 sx={{
//                   fontWeight: 600,
//                   boxShadow: `0 4px 12px ${alpha(theme.palette.error.main, 0.3)}`,
//                   '&:hover': {
//                     boxShadow: `0 6px 16px ${alpha(theme.palette.error.main, 0.4)}`,
//                   }
//                 }}
//               >
//                 Delete Order
//               </Button>
//             </Stack>
//           </Box>
//         </Fade>
//       </Modal>
//     </>
//   );
// };

// export default OfferList;



import React, { useState, useEffect, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Card,
  TextField,
  Box,
  Stack,
  IconButton,
  Skeleton,
  Modal,
  Button,
  Tooltip,
  Typography,
  Avatar,
  Chip,
  InputAdornment,
  useTheme,
  alpha,
  LinearProgress,
  Fade,
  Alert,
  PaginationItem,
  useMediaQuery,
  Hidden,
} from "@mui/material";
import {
  MdVisibility,
  MdDelete,
  MdSearch,
  MdClear,
  MdInbox,
  MdWarning,
  MdArrowBack,
  MdArrowForward,
  MdPhone,
  MdCalendarToday,
} from "react-icons/md";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import dayjs from "dayjs";

const OfferList = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [data, setData] = useState({ list: [], totalCount: 0, totalPages: 1, currentPage: 1 });
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedPromocodeId, setSelectedPromocodeId] = useState(null);
  const [error, setError] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);

  const getStatusConfig = (status) => {
    const normalizedStatus = status?.toLowerCase();
    const configs = {
      "delivered": {
        color: "#4caf50",
        bgColor: alpha("#4caf50", 0.1),
      },
      "pending": {
        color: "#ff9800",
        bgColor: alpha("#ff9800", 0.1),
      },
      "processing": {
        color: "#2196f3",
        bgColor: alpha("#2196f3", 0.1),
      },
      "confirmed": {
        color: "#9c27b0",
        bgColor: alpha("#9c27b0", 0.1),
      },
      "order cancelled": {
        color: "#f44336",
        bgColor: alpha("#f44336", 0.1),
      },
      "cancelled": {
        color: "#f44336",
        bgColor: alpha("#f44336", 0.1),
      }
    };
    return configs[normalizedStatus] || {
      color: "#757575",
      bgColor: alpha("#757575", 0.1),
    };
  };

  const getPaymentTypeConfig = (type) => {
    const configs = {
      "COD": {
        color: "#ff5722",
        bgColor: alpha("#ff5722", 0.1)
      },
      "Online": {
        color: "#4caf50",
        bgColor: alpha("#4caf50", 0.1)
      },
      "UPI": {
        color: "#673ab7",
        bgColor: alpha("#673ab7", 0.1)
      },
      "Card": {
        color: "#009688",
        bgColor: alpha("#009688", 0.1)
      }
    };
    return configs[type] || {
      color: "#757575",
      bgColor: alpha("#757575", 0.1)
    };
  };

  const fetchData = useCallback(
    debounce(async (page, query) => {
      setLoading(true);
      setSearchLoading(true);
      setError(null);
      
      try {
        const { data: responseData } = await axios.get(
          `https://api.medstown.com/customer/history/orders?page=${page}&search=${query}`
        );
        
        setData(responseData);
        if (responseData.currentPage) {
          setCurrentPage(responseData.currentPage);
        }
        
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.response?.data?.message || "Failed to fetch order history. Please try again.");
        setData({ list: [], totalCount: 0, totalPages: 1, currentPage: 1 });
      } finally {
        setLoading(false);
        setSearchLoading(false);
      }
    }, 500),
    []
  );

  useEffect(() => {
    fetchData(currentPage, searchQuery);
  }, [currentPage, searchQuery, fetchData]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
    setSearchLoading(true);
  };

  const clearSearch = () => {
    setSearchQuery("");
    setCurrentPage(1);
  };

  const handleConfirmDeletePromocode = async () => {
    try {
      const res = await fetch(
        `https://api.medstown.com/api/admin-controls/order/${selectedPromocodeId}`,
        {
          method: "DELETE",
        }
      );
      const data = await res.json();

      if (res.ok) {
        alert("Order deleted successfully");
        fetchData(currentPage, searchQuery);
      } else {
        alert(data.message || "Failed to delete order");
      }
    } catch (err) {
      alert("Server error");
      console.error(err);
    } finally {
      setDeleteOpen(false);
      setSelectedPromocodeId(null);
    }
  };

  return (
    <>
      <Card sx={{ 
        mt: isMobile ? 2 : 3, 
        mx: isMobile ? 1 : 0,
        borderRadius: 3, 
        boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
        border: '1px solid',
        borderColor: alpha(theme.palette.divider, 0.1),
        overflow: 'hidden'
      }}>
        {/* Loading Progress Bar */}
        {loading && (
          <LinearProgress 
            sx={{ 
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 1,
              height: 3,
              '& .MuiLinearProgress-bar': {
                background: 'linear-gradient(90deg, #2196f3, #21cbf3, #2196f3)'
              }
            }} 
          />
        )}

        {/* Responsive Header */}
        <Box sx={{ p: isMobile ? 2 : 3, pb: 2 }}>
          <Stack 
            direction={isMobile ? "column" : "row"} 
            justifyContent="space-between" 
            alignItems={isMobile ? "stretch" : "center"} 
            spacing={isMobile ? 2 : 3}
          >
            <Box>
              <Typography 
                variant={isMobile ? "h6" : "h5"} 
                fontWeight={700} 
                color="primary.main" 
                sx={{ mb: 0.5 }}
              >
                Order History
              </Typography>
              {!isSmallMobile && (
                <Typography variant="body2" color="text.secondary">
                  {data?.totalCount || 0} total orders • Page {currentPage} of {data?.totalPages || 1}
                </Typography>
              )}
            </Box>

            {/* Responsive Search Bar */}
            <Box sx={{ width: isMobile ? '100%' : isTablet ? 350 : 400 }}>
              <TextField
                variant="outlined"
                size={isMobile ? "small" : "medium"}
                placeholder={isMobile ? "Search orders..." : "Search by Order ID, Customer Name, or Phone..."}
                value={searchQuery}
                onChange={handleSearch}
                fullWidth
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: alpha(theme.palette.background.paper, 0.8),
                    backdropFilter: 'blur(10px)',
                    borderRadius: isMobile ? 2 : 3,
                    fontSize: isMobile ? '0.8rem' : '0.875rem',
                    transition: 'all 0.3s ease',
                    '& fieldset': {
                      borderColor: alpha(theme.palette.primary.main, 0.2),
                      borderWidth: 2,
                    },
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.background.paper, 1),
                      '& fieldset': {
                        borderColor: alpha(theme.palette.primary.main, 0.4),
                      },
                    },
                    '&.Mui-focused': {
                      backgroundColor: alpha(theme.palette.background.paper, 1),
                      boxShadow: `0 0 0 4px ${alpha(theme.palette.primary.main, 0.1)}`,
                      '& fieldset': {
                        borderColor: theme.palette.primary.main,
                      },
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {searchLoading ? (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <LinearProgress 
                            sx={{ 
                              width: 20, 
                              height: 2,
                              borderRadius: 1
                            }} 
                          />
                        </Box>
                      ) : (
                        <MdSearch size={isMobile ? 18 : 20} color={theme.palette.primary.main} />
                      )}
                    </InputAdornment>
                  ),
                  endAdornment: searchQuery && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={clearSearch}
                        sx={{ 
                          color: theme.palette.text.secondary,
                          '&:hover': { 
                            backgroundColor: alpha(theme.palette.error.main, 0.1),
                            color: theme.palette.error.main 
                          }
                        }}
                      >
                        <MdClear size={16} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Stack>

          {/* Error Alert */}
          {error && (
            <Fade in={!!error}>
              <Alert 
                severity="error" 
                sx={{ mt: 2, borderRadius: 2 }}
                icon={<MdWarning />}
                action={
                  <IconButton
                    size="small"
                    onClick={() => setError(null)}
                    sx={{ color: 'inherit' }}
                  >
                    <MdClear size={16} />
                  </IconButton>
                }
              >
                {error}
              </Alert>
            </Fade>
          )}
        </Box>

        {/* Mobile-Optimized Table */}
        <TableContainer 
          sx={{ 
            px: isMobile ? 1 : 3,
            // Enable horizontal scrolling on mobile
            ...(isMobile && {
              '& .MuiTable-root': {
                minWidth: 700, // Set minimum width for horizontal scroll
              }
            })
          }}
        >
          <Table 
            size={isMobile ? "small" : "small"} 
            sx={{ 
              '& .MuiTableCell-root': { 
                py: isMobile ? 1.5 : 2,
                px: isMobile ? 1 : 1.5,
                fontSize: isMobile ? '0.75rem' : '0.8125rem'
              }
            }}
          >
            <TableHead>
              <TableRow sx={{ '& .MuiTableCell-head': { 
                backgroundColor: alpha(theme.palette.primary.main, 0.06),
                fontWeight: 700,
                fontSize: isMobile ? '0.7rem' : '0.8rem',
                color: theme.palette.primary.main,
                border: 'none',
                py: isMobile ? 1.5 : 2,
                px: isMobile ? 1 : 1.5,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                whiteSpace: 'nowrap'
              }}}>
                <TableCell sx={{ minWidth: isMobile ? 80 : 'auto' }}>ID</TableCell>
                <TableCell sx={{ minWidth: isMobile ? 60 : 'auto' }}>Type</TableCell>
                <TableCell sx={{ minWidth: isMobile ? 100 : 'auto' }}>Customer</TableCell>
                {/* Show contact on all screens but make it smaller on mobile */}
                <TableCell sx={{ minWidth: isMobile ? 90 : 'auto' }}>
                  {isMobile ? "Phone" : "Contact"}
                </TableCell>
                <TableCell align="right" sx={{ minWidth: isMobile ? 70 : 'auto' }}>Amount</TableCell>
                <TableCell sx={{ minWidth: isMobile ? 70 : 'auto' }}>Payment</TableCell>
                <TableCell sx={{ minWidth: isMobile ? 80 : 'auto' }}>Status</TableCell>
                {/* Hide created date only on very small screens */}
                {!isSmallMobile && (
                  <TableCell sx={{ minWidth: isMobile ? 80 : 'auto' }}>Created</TableCell>
                )}
                <TableCell align="center" sx={{ minWidth: isMobile ? 80 : 'auto' }}>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading && !data?.list?.length ? (
                Array.from(new Array(6)).map((_, index) => (
                  <TableRow key={index}>
                    {[...Array(isSmallMobile ? 8 : 9)].map((_, i) => (
                      <TableCell key={i}>
                        <Skeleton 
                          variant="rectangular" 
                          height={isMobile ? 24 : 28} 
                          sx={{ borderRadius: 1.5, bgcolor: alpha(theme.palette.primary.main, 0.05) }} 
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : data?.list?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={isSmallMobile ? 8 : 9} align="center" sx={{ py: 8 }}>
                    <Stack direction="column" alignItems="center" spacing={3}>
                      <Avatar sx={{ 
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                        width: isMobile ? 56 : 72,
                        height: isMobile ? 56 : 72
                      }}>
                        <MdInbox size={isMobile ? 28 : 36} color={theme.palette.primary.main} />
                      </Avatar>
                      <Box textAlign="center">
                        <Typography variant={isMobile ? "body1" : "h6"} color="text.primary" fontWeight={600} sx={{ mb: 1 }}>
                          No orders found
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {searchQuery ? 'Try adjusting your search terms' : 'No order history available at the moment'}
                        </Typography>
                      </Box>
                    </Stack>
                  </TableCell>
                </TableRow>
              ) : (
                data?.list?.map((item) => {
                  const statusConfig = getStatusConfig(item.status);
                  const paymentConfig = getPaymentTypeConfig(item.paymentType);
                  
                  return (
                    <TableRow 
                      key={item._id}
                      sx={{ 
                        '&:hover': { 
                          backgroundColor: alpha(theme.palette.primary.main, 0.03),
                          ...(isMobile && {
                            transform: 'none', // Disable transform on mobile for better performance
                          }),
                          ...(!isMobile && {
                            transform: 'translateY(-1px)',
                            boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.1)}`
                          })
                        },
                        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {/* Order ID */}
                      <TableCell sx={{ fontSize: isMobile ? '0.7rem' : '0.8125rem', fontWeight: 600 }}>
                        <Box component="span" sx={{ 
                          color: theme.palette.primary.main,
                          fontFamily: 'monospace',
                          backgroundColor: alpha(theme.palette.primary.main, 0.08),
                          px: isMobile ? 0.5 : 1,
                          py: 0.25,
                          borderRadius: 1,
                          fontSize: isMobile ? '0.65rem' : '0.75rem',
                          display: 'block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: isMobile ? 70 : 'none'
                        }}>
                          {isMobile ? item.orderId.slice(-6) : item.orderId}
                        </Box>
                      </TableCell>
                      
                      {/* Order Type */}
                      <TableCell sx={{ fontSize: isMobile ? '0.7rem' : '0.8125rem' }}>
                        <Chip 
                          label={item.orderType?.replace("Pharmacy", "").trim()}
                          size="small"
                          variant="outlined"
                          sx={{ 
                            fontSize: isMobile ? '0.6rem' : '0.7rem', 
                            height: isMobile ? 20 : 26,
                            borderColor: alpha(theme.palette.secondary.main, 0.4),
                            color: theme.palette.secondary.main,
                            fontWeight: 500,
                            '& .MuiChip-label': {
                              px: isMobile ? 0.5 : 1
                            }
                          }}
                        />
                      </TableCell>
                      
                      {/* Customer */}
                      <TableCell sx={{ 
                        fontSize: isMobile ? '0.7rem' : '0.8125rem', 
                        maxWidth: isMobile ? 100 : 120 
                      }}>
                        <Box sx={{ 
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          fontWeight: 500
                        }}>
                          {item.customerName}
                        </Box>
                      </TableCell>
                      
                      {/* Contact */}
                      <TableCell sx={{ fontSize: isMobile ? '0.65rem' : '0.8125rem' }}>
                        <Stack direction="row" alignItems="center" spacing={isMobile ? 0.5 : 1}>
                          {!isMobile && <MdPhone size={14} color={theme.palette.text.secondary} />}
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontFamily: 'monospace', 
                              fontSize: isMobile ? '0.65rem' : '0.8125rem',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {isMobile ? item.customerPhone.slice(-10) : item.customerPhone}
                          </Typography>
                        </Stack>
                      </TableCell>
                      
                      {/* Amount */}
                      <TableCell align="right" sx={{ 
                        fontSize: isMobile ? '0.7rem' : '0.8125rem', 
                        fontWeight: 700 
                      }}>
                        <Box sx={{ 
                          color: theme.palette.success.main,
                          whiteSpace: 'nowrap'
                        }}>
                          ₹{isMobile 
                            ? (item.totalPrice > 999 
                                ? `${(item.totalPrice / 1000).toFixed(1)}k` 
                                : item.totalPrice)
                            : item.totalPrice?.toLocaleString()
                          }
                        </Box>
                      </TableCell>
                      
                      {/* Payment */}
                      <TableCell sx={{ fontSize: isMobile ? '0.7rem' : '0.8125rem' }}>
                        <Chip 
                          label={item.paymentType}
                          size="small"
                          sx={{ 
                            fontSize: isMobile ? '0.6rem' : '0.7rem',
                            height: isMobile ? 18 : 24,
                            backgroundColor: paymentConfig.bgColor,
                            color: paymentConfig.color,
                            border: 'none',
                            fontWeight: 600,
                            '& .MuiChip-label': {
                              px: isMobile ? 0.5 : 1
                            }
                          }}
                        />
                      </TableCell>
                      
                      {/* Status */}
                      <TableCell sx={{ fontSize: isMobile ? '0.7rem' : '0.8125rem' }}>
                        <Chip 
                          label={isMobile ? item.status.slice(0, 8) : item.status}
                          size="small"
                          sx={{ 
                            fontSize: isMobile ? '0.6rem' : '0.7rem',
                            height: isMobile ? 20 : 26,
                            backgroundColor: statusConfig.bgColor,
                            color: statusConfig.color,
                            border: `1px solid ${alpha(statusConfig.color, 0.3)}`,
                            fontWeight: 600,
                            '& .MuiChip-label': {
                              px: isMobile ? 0.5 : 1
                            }
                          }}
                        />
                      </TableCell>

                      {/* Created Date - Hidden on very small mobile */}
                      {!isSmallMobile && (
                        <TableCell sx={{ 
                          fontSize: isMobile ? '0.65rem' : '0.75rem', 
                          color: 'text.secondary' 
                        }}>
                          <Stack direction="row" alignItems="center" spacing={isMobile ? 0.5 : 1}>
                            {!isMobile && <MdCalendarToday size={14} />}
                            <Box>
                              <Box sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
                                {dayjs(item.createdAt).format(isMobile ? "MMM DD" : "MMM DD")}
                              </Box>
                              {!isMobile && (
                                <Box sx={{ fontSize: '0.7rem', opacity: 0.8 }}>
                                  {dayjs(item.createdAt).format("hh:mm A")}
                                </Box>
                              )}
                            </Box>
                          </Stack>
                        </TableCell>
                      )}
                      
                      {/* Actions */}
                      <TableCell align="center">
                        <Stack 
                          direction="row" 
                          spacing={isMobile ? 0.5 : 1} 
                          justifyContent="center"
                        >
                          {/* View Button */}
                          <Tooltip title="View Order Details">
                            <IconButton
                              size="small"
                              onClick={() => navigate(`/admin/open-order/${item.orderId}`)}
                              sx={{ 
                                color: theme.palette.primary.main,
                                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                                width: isMobile ? 28 : 32,
                                height: isMobile ? 28 : 32,
                                '&:hover': {
                                  backgroundColor: alpha(theme.palette.primary.main, 0.2),
                                  transform: isMobile ? 'none' : 'scale(1.05)',
                                  boxShadow: `0 4px 8px ${alpha(theme.palette.primary.main, 0.3)}`
                                },
                                transition: 'all 0.2s ease'
                              }}
                            >
                              <MdVisibility size={isMobile ? 14 : 16} />
                            </IconButton>
                          </Tooltip>

                          {/* Delete Button */}
                          <Tooltip title="Delete Order (Not Working)">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setSelectedPromocodeId(item.orderId);
                                setDeleteOpen(true);
                              }}
                              sx={{ 
                                color: theme.palette.error.main,
                                backgroundColor: alpha(theme.palette.error.main, 0.1),
                                border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
                                width: isMobile ? 28 : 32,
                                height: isMobile ? 28 : 32,
                                '&:hover': {
                                  backgroundColor: alpha(theme.palette.error.main, 0.2),
                                  transform: isMobile ? 'none' : 'scale(1.05)',
                                  boxShadow: `0 4px 8px ${alpha(theme.palette.error.main, 0.3)}`
                                },
                                transition: 'all 0.2s ease'
                              }}
                            >
                              <MdDelete size={isMobile ? 14 : 16} />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Enhanced Responsive Pagination */}
        <Box sx={{ p: isMobile ? 2 : 3, pt: 2 }}>
          <Stack 
            direction={isMobile ? "column" : "row"} 
            justifyContent="space-between" 
            alignItems="center"
            spacing={isMobile ? 2 : 0}
          >
            {/* Results Info */}
            <Typography 
              variant="body2" 
              color="text.secondary" 
              sx={{ 
                fontWeight: 500,
                fontSize: isMobile ? '0.75rem' : '0.875rem',
                order: isMobile ? 2 : 1
              }}
            >
              Showing {data?.list?.length || 0} of {data?.totalCount || 0} orders
            </Typography>

            {/* Pagination */}
            {data?.totalPages > 1 && (
              <Pagination
                count={data?.totalPages || 1}
                page={currentPage}
                onChange={handlePageChange}
                size={isMobile ? "small" : "medium"}
                variant="outlined"
                shape="rounded"
                siblingCount={isMobile ? 0 : 1}
                boundaryCount={isMobile ? 1 : 2}
                sx={{ order: isMobile ? 1 : 2 }}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: MdArrowBack, next: MdArrowForward }}
                    {...item}
                    sx={{
                      fontSize: isMobile ? '0.75rem' : '0.875rem',
                      minWidth: isMobile ? 28 : 36,
                      height: isMobile ? 28 : 36,
                      margin: isMobile ? '0 1px' : '0 2px',
                      borderRadius: 2,
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                      '&.Mui-selected': {
                        backgroundColor: theme.palette.primary.main,
                        color: 'white',
                        fontWeight: 600,
                        border: `1px solid ${theme.palette.primary.main}`,
                        '&:hover': {
                          backgroundColor: alpha(theme.palette.primary.main, 0.8),
                        }
                      },
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                        borderColor: alpha(theme.palette.primary.main, 0.4),
                      }
                    }}
                  />
                )}
              />
            )}
          </Stack>
        </Box>
      </Card>

      {/* Enhanced Responsive Delete Modal */}
      <Modal
        open={deleteOpen}
        onClose={() => {
          setDeleteOpen(false);
          setSelectedPromocodeId(null);
        }}
        closeAfterTransition
      >
        <Fade in={deleteOpen}>
          <Box sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? '90vw' : isTablet ? 400 : 480,
            maxWidth: 480,
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: `0 24px 48px ${alpha(theme.palette.common.black, 0.15)}`,
            p: isMobile ? 3 : 4,
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            mx: isMobile ? 2 : 0
          }}>
            {/* Modal Header */}
            <Stack 
              direction={isMobile ? "column" : "row"} 
              alignItems={isMobile ? "center" : "center"} 
              spacing={2} 
              sx={{ mb: 3 }}
            >
              <Avatar sx={{
                backgroundColor: alpha(theme.palette.error.main, 0.1),
                color: theme.palette.error.main,
                width: isMobile ? 56 : 48,
                height: isMobile ? 56 : 48
              }}>
                <MdWarning size={isMobile ? 28 : 24} />
              </Avatar>
              <Box sx={{ textAlign: isMobile ? 'center' : 'left' }}>
                <Typography 
                  variant={isMobile ? "h6" : "h5"} 
                  fontWeight={700} 
                  color="error.main"
                >
                  Delete Order History
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  This action cannot be undone
                </Typography>
              </Box>
            </Stack>

            {/* Modal Content */}
            <Box sx={{ 
              backgroundColor: alpha(theme.palette.error.main, 0.05),
              p: isMobile ? 2 : 3,
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
              mb: isMobile ? 3 : 4
            }}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Are you sure you want to delete this order history?
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Order ID:</strong> #{selectedPromocodeId}
              </Typography>
            </Box>

            {/* Modal Actions */}
            <Stack 
              direction={isMobile ? "column-reverse" : "row"} 
              spacing={2} 
              justifyContent="flex-end"
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setDeleteOpen(false);
                  setSelectedPromocodeId(null);
                }}
                fullWidth={isMobile}
                sx={{
                  borderColor: alpha(theme.palette.text.secondary, 0.3),
                  color: 'text.secondary',
                  '&:hover': {
                    borderColor: theme.palette.text.secondary,
                    backgroundColor: alpha(theme.palette.text.secondary, 0.05)
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleConfirmDeletePromocode}
                fullWidth={isMobile}
                sx={{
                  fontWeight: 600,
                  boxShadow: `0 4px 12px ${alpha(theme.palette.error.main, 0.3)}`,
                  '&:hover': {
                    boxShadow: `0 6px 16px ${alpha(theme.palette.error.main, 0.4)}`,
                  }
                }}
              >
                Delete Order
              </Button>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default OfferList;
